import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  Clock, 
  User, 
  CheckCircle, 
  Star, 
  ArrowRight, 
  Phone,
  Calendar,
  MapPin,
  Users,
  Award,
  BookOpen,
  Code,
  Brain,
  Target,
  TrendingUp,
  MessageCircle,
  Play,
  Trophy,
  Shield,
  Zap,
  ChevronRight,
  ChevronLeft,
  Quote,
  Sparkles,
  Rocket,
  Globe,
  Building2,
  GraduationCap,
  Briefcase,
  DollarSign,
  Heart,
  Eye,
  MousePointer,
  BarChart3,
  Lightbulb,
  Cpu,
  Database,
  Layers,
  GitBranch,
  Server,
  Monitor,
  Smartphone,
  Tablet,
  Wifi,
  Lock,
  Unlock,
  RefreshCw,
  Maximize2,
  Minimize2,
  RotateCcw,
  RotateCw,
  ZoomIn,
  ZoomOut,
  Move,
  Copy,
  Scissors,
  FileText,
  Image,
  Video,
  Music,
  File,
  Folder,
  HardDrive,
  Cloud,
  Download,
  Upload,
  Share2,
  Mail,
  Bell,
  Settings,
  Search,
  Filter,
  Grid,
  List,
  Menu,
  X,
  Plus,
  Minus,
  Edit,
  Trash2,
  Save
} from 'lucide-react';
import CountdownTimer from '../components/CountdownTimer';

const MasterclassSolid = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [whatsappUpdates, setWhatsappUpdates] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [currentAlumni, setCurrentAlumni] = useState(0);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');

  // Scroll effect for enhanced UX
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Auto-rotate alumni
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAlumni((prev) => (prev + 1) % alumni.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleRegister = (e) => {
    e.preventDefault();
    // Handle registration logic here
  };

  const testimonials = [
    {
      name: "Shubh Agrawal",
      role: "BTech CSE",
      source: "Quora",
      quote: "As a regular attendee of OSOP masterclasses, I can confidently say the quality is unparalleled. The S.O.L.I.D principles masterclass completely transformed my approach to software design.",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
    },
    {
      name: "Priya Sharma",
      role: "Software Developer",
      source: "LinkedIn",
      quote: "The practical examples and real-world applications made complex concepts crystal clear. This masterclass is a must for any developer serious about writing better code.",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face"
    },
    {
      name: "Rahul Verma",
      role: "Full Stack Developer",
      source: "Quora",
      quote: "From understanding single responsibility to mastering dependency inversion, this masterclass covered everything. The instructor's expertise is evident in every explanation.",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
    }
  ];

  const alumni = [
    {
      name: "Amit Patel",
      joinDate: "Jan 2023",
      preCompany: "TCS",
      preRole: "Associate",
      postCompany: "Amazon",
      postRole: "SDE II",
      salaryHike: "112%",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
    },
    {
      name: "Neha Singh",
      joinDate: "Mar 2023",
      preCompany: "Infosys",
      preRole: "System Engineer",
      postCompany: "Google",
      postRole: "Software Engineer",
      salaryHike: "300%",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face"
    },
    {
      name: "Vikram Kumar",
      joinDate: "Jun 2023",
      preCompany: "Wipro",
      preRole: "Project Engineer",
      postCompany: "Microsoft",
      postRole: "SDE",
      salaryHike: "180%",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
    },
    {
      name: "Anjali Desai",
      joinDate: "Sep 2023",
      preCompany: "HCL",
      preRole: "Software Engineer",
      postCompany: "Netflix",
      postRole: "Backend Engineer",
      salaryHike: "250%",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face"
    }
  ];

  const upcomingEvents = [
    {
      title: "How to get an SDE Job Outside India?",
      date: "July 22nd, 2024",
      time: "7:00 PM - 9:00 PM",
      instructor: "Rahul Sharma"
    },
    {
      title: "System Design Masterclass",
      date: "July 29th, 2024",
      time: "6:30 PM - 9:30 PM",
      instructor: "Priya Gupta"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-brand-orange/5 dark:from-gray-900 dark:via-gray-800 dark:to-brand-orange/10">
      {/* Floating OSOPCoding Badge */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="absolute top-24 left-8 z-10 hidden md:block"
      >
        <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-md rounded-2xl p-2 shadow-lg border border-gray-200/50 dark:border-gray-700/50 flex items-center">
          <div className="w-8 h-8 bg-brand-orange rounded-xl flex items-center justify-center mr-3">
            <Code className="w-5 h-5 text-white" />
          </div>
          <span className="font-bold text-xl text-brand-orange tracking-tight">OSOPCoding</span>
        </div>
      </motion.div>
      {/* Hero Section */}
      {/* HERO SECTION REFACTOR - CENTERED LAYOUT */}
      <section
        className="relative flex items-center justify-center min-h-[calc(100vh-96px)] pt-20 pb-8 px-4 mt-12 overflow-hidden
    bg-white bg-[url('data:image/svg+xml,%3Csvg width=\'600\' height=\'600\' viewBox=\'0 0 600 600\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M0 0C150 100 450 100 600 0V600H0V0Z\' fill=\'%23fff5e6\'/%3E%3Cpath d=\'M0 100C200 200 400 200 600 100V600H0V100Z\' fill=\'%23ffe0b2\' fill-opacity=\'0.5\'/%3E%3Cpath d=\'M0 200C150 300 450 300 600 200V600H0V200Z\' fill=\'%23ffb74d\' fill-opacity=\'0.15\'/%3E%3Cpath d=\'M0 300C200 400 400 400 600 300V600H0V300Z\' fill=\'%23ff9800\' fill-opacity=\'0.08\'/%3E%3C/svg%3E')] dark:bg-gradient-to-br dark:from-brand-orange/20 dark:via-gray-900 dark:to-brand-orange/30"
        style={{ minHeight: 'calc(100vh - 96px)' }}
      >
        {/* Animated Gradient Background */}
        <div className="absolute inset-0 z-0 animate-gradient-move bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-orange/10 via-white/30 to-brand-orange/10 dark:from-brand-orange/20 dark:via-gray-900/60 dark:to-brand-orange/20"></div>

        <div className="w-full max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center relative z-10">
          {/* Left: Headline, Subheadline, USPs, Instructor */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-6">
            {/* Headline */}
            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-4xl md:text-5xl xl:text-6xl font-extrabold text-gray-900 dark:text-white leading-tight drop-shadow-lg"
              style={{ lineHeight: 1.1 }}
            >
              Master the <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-orange via-orange-500 to-red-600 animate-gradient-text">S.O.L.I.D</span> Principles
            </motion.h1>
            {/* Subheadline */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.2 }}
              className="text-lg md:text-xl text-gray-600 dark:text-gray-300 font-medium max-w-xl"
            >
              <span className="text-brand-orange font-semibold">Google's secret</span> is S.O.L.I.D – Master it with OSOP!
            </motion.p>
            {/* USPs */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.3 }}
              className="flex flex-wrap justify-center md:justify-start gap-3"
            >
              {[
                { icon: <CheckCircle className="w-5 h-5 text-green-500" />, label: 'Industry Experts' },
                { icon: <CheckCircle className="w-5 h-5 text-green-500" />, label: 'Live Projects' },
                { icon: <CheckCircle className="w-5 h-5 text-green-500" />, label: 'Career Support' },
              ].map((usp, i) => (
                <span key={i} className="inline-flex items-center px-4 py-2 bg-white/80 dark:bg-gray-800/80 border border-brand-orange/20 rounded-full text-sm font-semibold text-gray-800 dark:text-gray-200 shadow-sm gap-2">
                  {usp.icon} {usp.label}
                </span>
              ))}
            </motion.div>
            {/* Roadmap Note */}
            <motion.p
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.4 }}
              className="text-sm text-gray-500 dark:text-gray-400"
            >
              Roadmap to CEC, IIT‑Roorkee Certified AI Engineering Program
            </motion.p>
            {/* Instructor Card */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              className="flex items-center space-x-4 bg-white/90 dark:bg-gray-800/90 rounded-2xl p-4 shadow-lg border border-gray-200/50 dark:border-gray-700/50 mt-2 w-full max-w-xs mx-auto md:mx-0"
            >
              <div className="relative w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden border-4 border-brand-orange shadow-lg">
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face" alt="Instructor" className="w-full h-full object-cover" />
              </div>
              <div>
                <p className="font-bold text-gray-900 dark:text-white text-lg">By [Your Name]</p>
                <p className="text-xs text-gray-600 dark:text-gray-400">Sr. Software Engineer & OSOP Expert Instructor</p>
                <div className="flex items-center space-x-1 mt-1">
                  <Star className="w-4 h-4 text-yellow-500 fill-current" />
                  <span className="text-xs text-gray-500">4.9/5 (2,847 reviews)</span>
                </div>
              </div>
            </motion.div>
          </div>
          {/* Right: Registration Card */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="flex justify-center items-center w-full"
          >
            {/* Enhanced Registration Form */}
            <div className="bg-gradient-to-br from-white via-gray-50 to-white dark:from-gray-800 dark:via-gray-700 dark:to-gray-800 rounded-3xl p-8 shadow-2xl border border-gray-200/50 dark:border-gray-700/50 backdrop-blur-sm">
              {/* OSOP Branding Header */}
              <div className="text-center mb-8">
                <div className="flex items-center justify-center space-x-3 mb-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-brand-orange to-orange-600 rounded-2xl flex items-center justify-center">
                    <Code className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">OSOP Academy</h2>
                    <p className="text-sm text-gray-600 dark:text-gray-400">Premium Masterclass</p>
                  </div>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Register for Free</h3>
                <p className="text-gray-600 dark:text-gray-400">Join 3,000+ developers already registered</p>
              </div>
              
              <form onSubmit={handleRegister} className="space-y-6">
                {/* Enhanced Phone Input */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
                    <Phone className="inline w-4 h-4 mr-2 text-brand-orange" />
                    Phone Number
                  </label>
                  <div className="relative group">
                    <select className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-transparent text-gray-500 border-none focus:outline-none z-10">
                      <option>+91 🇮🇳</option>
                      <option>+1 🇺🇸</option>
                      <option>+44 🇬🇧</option>
                      <option>+61 🇦🇺</option>
                    </select>
                    <input
                      type="tel"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder="Enter your phone number"
                      className="w-full pl-16 pr-4 py-4 border-2 border-gray-200 dark:border-gray-600 rounded-2xl focus:ring-2 focus:ring-brand-orange focus:border-brand-orange bg-white dark:bg-gray-700 text-gray-900 dark:text-white transition-all duration-200 group-hover:border-brand-orange/50"
                      required
                    />
                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                      <Phone className="w-5 h-5 text-gray-400" />
                    </div>
                  </div>
                </div>

                {/* Enhanced Submit Button */}
                <motion.button
                  type="submit"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold py-5 px-6 rounded-2xl transition-all duration-200 shadow-xl hover:shadow-2xl text-lg"
                >
                  <div className="flex items-center justify-center space-x-2">
                    <Rocket className="w-5 h-5" />
                    <span>Register for Free Masterclass</span>
                  </div>
                </motion.button>
              </form>

              {/* Enhanced Footer */}
              <div className="mt-8 space-y-4">
                {/* Social Proof */}
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 rounded-xl p-4 border border-green-200 dark:border-green-800">
                  <div className="flex items-center justify-center space-x-2 text-green-700 dark:text-green-400">
                    <Users className="w-5 h-5" />
                    <span className="font-semibold">3,247+ developers already registered</span>
                  </div>
                </div>

                {/* Trust Indicators */}
                <div className="flex items-center justify-center space-x-6 text-xs text-gray-500 dark:text-gray-400">
                  <div className="flex items-center space-x-1">
                    <Shield className="w-3 h-3" />
                    <span>100% Free</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Lock className="w-3 h-3" />
                    <span>Secure</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Clock className="w-3 h-3" />
                    <span>3 Hours</span>
                  </div>
                </div>

                <p className="text-xs text-gray-500 dark:text-gray-500 text-center">
                  By registering, you agree to our{' '}
                  <span className="text-brand-orange hover:underline cursor-pointer">terms and conditions</span>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      {/* HERO SECTION REFACTOR END */}

      {/* OSOP Achievement Stats */}
      <section className="py-16 bg-gradient-to-r from-brand-orange/10 via-white to-brand-orange/10 dark:from-brand-orange/5 dark:via-gray-800 dark:to-brand-orange/5">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white mb-4">
              Why Developers Choose <span className="text-brand-orange">OSOP Academy</span>
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Join thousands of successful developers who transformed their careers with OSOP
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            {[
              { number: "15,000+", label: "Students Trained", icon: <Users className="w-8 h-8" /> },
              { number: "95%", label: "Placement Rate", icon: <TrendingUp className="w-8 h-8" /> },
              { number: "₹12L", label: "Avg. Package", icon: <DollarSign className="w-8 h-8" /> },
              { number: "500+", label: "Companies", icon: <Building2 className="w-8 h-8" /> }
            ].map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center"
              >
                <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border border-gray-200/50 dark:border-gray-700/50 hover:shadow-xl transition-shadow">
                  <div className="text-brand-orange mb-3 flex justify-center">
                    {stat.icon}
                  </div>
                  <div className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                    {stat.number}
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-400 font-medium">
                    {stat.label}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Sticky CTA Button */}
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: isScrolled ? 1 : 0, y: isScrolled ? 0 : 100 }}
        transition={{ duration: 0.3 }}
        className="fixed bottom-6 right-6 z-50"
      >
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="bg-gradient-to-r from-brand-orange to-orange-600 text-white px-6 py-4 rounded-2xl font-bold shadow-2xl hover:shadow-3xl transition-all duration-200 flex items-center space-x-2"
        >
          <Rocket className="w-5 h-5" />
          <span>Register Now!</span>
        </motion.button>
      </motion.div>

      {/* Enhanced About This Masterclass */}
      <section className="py-20 bg-gradient-to-br from-white via-gray-50 to-white dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="max-w-5xl mx-auto"
          >
            {/* Header */}
            <div className="text-center mb-16">
              <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-brand-orange/20 to-orange-500/20 text-brand-orange rounded-full text-sm font-semibold mb-6">
                <BookOpen className="w-4 h-4 mr-2" />
                OSOP Exclusive Masterclass
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-6">
                About this <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-orange to-orange-600">Masterclass</span>
              </h2>
              
              <p className="text-xl text-gray-600 dark:text-gray-300 leading-relaxed max-w-3xl mx-auto">
                Good developers know concepts, great developers understand deep technical details. 
                At <span className="text-brand-orange font-semibold">OSOP Academy</span>, we help you master S.O.L.I.D principles to build robust, 
                scalable, and maintainable systems that stand the test of time.
              </p>
            </div>

            {/* Enhanced CTA Box */}
            <div className="bg-gradient-to-r from-brand-orange/10 via-orange-500/10 to-brand-orange/10 rounded-3xl p-8 border-2 border-brand-orange/20 shadow-xl mb-16">
              <div className="text-center">
                <div className="flex items-center justify-center space-x-3 mb-4">
                  <div className="w-12 h-12 bg-brand-orange rounded-full flex items-center justify-center">
                    <Rocket className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Ready to leap from good to great?
                  </h3>
                </div>
                <p className="text-gray-600 dark:text-gray-300 mb-6 max-w-2xl mx-auto">
                  Join thousands of developers who have already transformed their coding skills with OSOP's expert-led masterclasses
                </p>
                <motion.button 
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-gradient-to-r from-brand-orange to-orange-600 text-white px-10 py-4 rounded-2xl font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-200"
                >
                  <div className="flex items-center space-x-2">
                    <Zap className="w-5 h-5" />
                    <span>Register Now - It's Free!</span>
                  </div>
                </motion.button>
              </div>
            </div>

            {/* Enhanced What You Will Gain Section */}
            <div className="mt-16">
              <div className="text-center mb-12">
                <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white mb-4">
                  What You Will Gain From This <span className="text-brand-orange">OSOP Masterclass</span>
                </h3>
                <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
                  Transform your coding skills with industry-proven techniques taught by OSOP experts
                </p>
              </div>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {[
                  {
                    title: "Master S.O.L.I.D Principles",
                    description: "Understand the core principles that make code maintainable and scalable",
                    icon: <Code className="w-6 h-6" />
                  },
                  {
                    title: "Single Responsibility",
                    description: "Learn why focused, single‑responsibility classes/methods matter",
                    icon: <Target className="w-6 h-6" />
                  },
                  {
                    title: "Extend Functionality",
                    description: "Master how to extend functionality & create correct relationships",
                    icon: <GitBranch className="w-6 h-6" />
                  },
                  {
                    title: "Design Interfaces",
                    description: "Learn to design interfaces & decouple systems effectively",
                    icon: <Layers className="w-6 h-6" />
                  },
                  {
                    title: "Build Robust Systems",
                    description: "Create robust, extensible, maintainable systems",
                    icon: <Server className="w-6 h-6" />
                  },
                  {
                    title: "OSOP Certification",
                    description: "Get certified by OSOP Academy with industry recognition",
                    icon: <Award className="w-6 h-6" />
                  }
                ].map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border border-gray-200/50 dark:border-gray-700/50 hover:shadow-xl transition-all duration-200 group"
                  >
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-gradient-to-r from-brand-orange/20 to-orange-500/20 rounded-xl flex items-center justify-center text-brand-orange group-hover:scale-110 transition-transform">
                        {item.icon}
                      </div>
                      <div className="flex-1">
                        <h4 className="font-bold text-gray-900 dark:text-white mb-2">
                          {item.title}
                        </h4>
                        <p className="text-sm text-gray-600 dark:text-gray-400">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Meet the Instructor */}
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="max-w-4xl mx-auto"
          >
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white text-center mb-12">
              Meet [Your Name]
            </h2>

            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-6">
                <div className="space-y-4">
                  {[
                    "Senior Software Engineer at [Company]",
                    "Instructor & Mentor, OSOP",
                    "[Your University/alumni credentials]",
                    "Former Platform Engineer at [Past Employer]",
                    "16+ years of programming experience"
                  ].map((item, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-orange rounded-full"></div>
                      <span className="text-lg text-gray-700 dark:text-gray-300">{item}</span>
                    </div>
                  ))}
                </div>

                <div className="bg-white dark:bg-gray-700 rounded-2xl p-6 border border-gray-200 dark:border-gray-600">
                  <p className="text-gray-700 dark:text-gray-300">
                    <strong>All attendees get certificates from [Name] and OSOP Academy.</strong>
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="w-80 h-80 mx-auto rounded-full overflow-hidden shadow-2xl">
                  <img
                    src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face"
                    alt="Instructor"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-4 -right-4 bg-brand-orange text-white rounded-full p-4 shadow-lg">
                  <Award className="w-8 h-8" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Who This Masterclass Is For */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-12">
              This Masterclass is for
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-4xl mx-auto">
              {[
                {
                  icon: <Code className="w-12 h-12" />,
                  title: "SDEs looking to upskill",
                  description: "Enhance your software design skills"
                },
                {
                  icon: <TrendingUp className="w-12 h-12" />,
                  title: "SDEs moving from service to product companies",
                  description: "Prepare for technical interviews"
                },
                {
                  icon: <Brain className="w-12 h-12" />,
                  title: "Developers wanting to write better code",
                  description: "Learn industry best practices"
                }
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow"
                >
                  <div className="text-brand-orange mb-4 flex justify-center">
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    {item.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-12">
              What our Learners have to say
            </h2>

            <div className="max-w-4xl mx-auto relative">
              <div className="relative overflow-hidden rounded-2xl">
                <motion.div
                  key={currentTestimonial}
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -100 }}
                  transition={{ duration: 0.5 }}
                  className="bg-white dark:bg-gray-700 rounded-2xl p-8 shadow-lg"
                >
                  <div className="flex items-center space-x-4 mb-6">
                    <img
                      src={testimonials[currentTestimonial].avatar}
                      alt={testimonials[currentTestimonial].name}
                      className="w-16 h-16 rounded-full object-cover"
                    />
                    <div className="text-left">
                      <h4 className="font-semibold text-gray-900 dark:text-white">
                        {testimonials[currentTestimonial].name}
                      </h4>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {testimonials[currentTestimonial].role} • {testimonials[currentTestimonial].source}
                      </p>
                    </div>
                  </div>
                  
                  <blockquote className="text-lg text-gray-700 dark:text-gray-300 italic">
                    "{testimonials[currentTestimonial].quote}"
                  </blockquote>
                </motion.div>
              </div>

              <div className="flex justify-center space-x-2 mt-8">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentTestimonial(index)}
                    className={`w-3 h-3 rounded-full transition-colors ${
                      index === currentTestimonial ? 'bg-brand-orange' : 'bg-gray-300 dark:bg-gray-600'
                    }`}
                  />
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Engagement Highlights */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-12">
              Your Learning Journey
            </h2>

            <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              {[
                {
                  icon: <BookOpen className="w-12 h-12" />,
                  title: "Register for the Masterclass",
                  description: "Secure your spot in this exclusive session"
                },
                {
                  icon: <MessageCircle className="w-12 h-12" />,
                  title: "Participate in LIVE Quizzes",
                  description: "Test your knowledge in real-time"
                },
                {
                  icon: <Trophy className="w-12 h-12" />,
                  title: "Conquer the Leaderboards",
                  description: "Compete with peers and track progress"
                }
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="text-center"
                >
                  <div className="bg-brand-orange/10 rounded-full w-24 h-24 mx-auto mb-6 flex items-center justify-center text-brand-orange">
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    {item.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* About OSOP Academy */}
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="max-w-4xl mx-auto"
          >
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white text-center mb-8">
              About OSOP Academy
            </h2>

            <div className="bg-white dark:bg-gray-700 rounded-3xl p-8 shadow-lg">
              <p className="text-xl text-gray-700 dark:text-gray-300 mb-8 leading-relaxed">
                Conventional learning often leaves gaps between theory and practice. At OSOP Academy, 
                we bridge this gap with structured, industry‑vetted curriculum designed to make you 
                a solid engineer.
              </p>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                {[
                  "Structured, guided, industry‑vetted curriculum",
                  "Live classes by experts",
                  "1:1 mentorship",
                  "Real‑life project experience",
                  "Career support, partner network",
                  "Electives (advanced DSA, etc.)"
                ].map((item, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <CheckCircle className="w-5 h-5 text-brand-orange flex-shrink-0" />
                    <span className="text-gray-700 dark:text-gray-300">{item}</span>
                  </div>
                ))}
              </div>

              <div className="bg-brand-orange/10 rounded-2xl p-6 border border-brand-orange/20">
                <p className="text-center text-gray-700 dark:text-gray-300">
                  <strong>Option to attend a free class, recorded content, mentor booking</strong>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-12">
              Discover successful alumni like you
            </h2>

            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                {alumni.map((person, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-6 text-center hover:shadow-lg transition-shadow"
                  >
                    <img
                      src={person.avatar}
                      alt={person.name}
                      className="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
                    />
                    <h4 className="font-semibold text-gray-900 dark:text-white mb-1">
                      {person.name}
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                      Joined {person.joinDate}
                    </p>
                    
                    <div className="space-y-2 text-sm">
                      <div className="bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400 rounded-lg px-3 py-1">
                        <strong>{person.salaryHike} hike</strong>
                      </div>
                      <div>
                        <p className="text-gray-500 dark:text-gray-500 text-xs">From</p>
                        <p className="font-medium text-gray-700 dark:text-gray-300">
                          {person.preCompany} • {person.preRole}
                        </p>
                      </div>
                      <div>
                        <p className="text-gray-500 dark:text-gray-500 text-xs">To</p>
                        <p className="font-medium text-gray-900 dark:text-white">
                          {person.postCompany} • {person.postRole}
                        </p>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Upcoming Events */}
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <div className="flex items-center justify-between mb-12">
              <h2 className="text-4xl font-bold text-gray-900 dark:text-white">
                Upcoming Events
              </h2>
              <button className="bg-brand-orange text-white px-6 py-3 rounded-xl font-semibold hover:bg-brand-orange/90 transition-colors">
                Explore All
              </button>
            </div>

            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              {upcomingEvents.map((event, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="bg-white dark:bg-gray-700 rounded-2xl p-6 shadow-lg"
                >
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                    {event.title}
                  </h3>
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center text-gray-600 dark:text-gray-400">
                      <Calendar className="w-4 h-4 mr-2" />
                      {event.date}
                    </div>
                    <div className="flex items-center text-gray-600 dark:text-gray-400">
                      <Clock className="w-4 h-4 mr-2" />
                      {event.time}
                    </div>
                    <div className="flex items-center text-gray-600 dark:text-gray-400">
                      <User className="w-4 h-4 mr-2" />
                      By {event.instructor}
                    </div>
                  </div>
                  <button className="w-full bg-brand-orange text-white py-3 rounded-xl font-semibold hover:bg-brand-orange/90 transition-colors">
                    Register Now
                  </button>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-r from-brand-orange to-orange-600">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="max-w-2xl mx-auto"
          >
            <h2 className="text-4xl font-bold text-white mb-6">
              Ready to Master S.O.L.I.D Principles?
            </h2>
            <p className="text-xl text-orange-100 mb-8">
              Join thousands of developers who have transformed their coding skills
            </p>
            <button className="bg-white text-brand-orange px-8 py-4 rounded-xl font-semibold text-lg hover:bg-gray-100 transition-colors">
              Register for Free Masterclass
            </button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default MasterclassSolid; 